import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

// The draft provider may unmount together with the form, dropping any pending
// throttled autosave — flush so the draft keeps the latest input. An explicit
// discard (setDraft(null, 0)) puts `null` in the throttle's latest slot; treat
// that as authoritative and skip the flush.
export function useDraftFlushOnUnmount({
  getDraftPayload,
  getIsDirty,
  getLatestDraft,
  setDraft,
}) {
  const { dirty, initialValues, values } = useFormikContext()

  const flushOnUnmountRef = useRef(null)

  function flushDraftOnUnmount() {
    if (
      getLatestDraft?.() !== null &&
      getIsDirty?.({ dirty, initialValues, values })
    ) {
      setDraft(getDraftPayload ? getDraftPayload(values) : values, 0)
    }
  }

  useEffect(() => {
    flushOnUnmountRef.current = flushDraftOnUnmount
  })

  useEffect(
    () => () => {
      flushOnUnmountRef.current?.()
    },
    []
  )
}
